import React from 'react';
import { t } from 'i18next';
import dayjs from '@fingo/lib/config/dayjs';
import AmountWithIvaCell from '@fingo/lib/components/cells/AmountWithIvaCell';
import CompanyCell from '@fingo/lib/components/cells/CompanyCell';
import DateCell from '@fingo/lib/components/cells/DateCell';
import FolioCell from '@fingo/lib/components/cells/FolioCell';
import PendingDocumentsManagerCell from '@fingo/lib/components/cells/PendingDocumentsManagerCell';
import UploadDocumentButton from '@fingo/lib/components/buttons/UploadDocumentButton';
import EvaluationStatusCell from '@fingo/lib/components/cells/EvaluationStatusCell';

export const INITIAL_ISSUED_DATE = dayjs()
  .subtract(1, 'month')
  .format('YYYY-MM-DD');

export const HEADERS = [
  'folio',
  'dteType_Code',
  'dateIssued',
  'receiver_sortable',
  'amountWithIva',
  'preoffer_Preofferevaluationrequest_Status',
  'uploadDocuments',
];

export const BUTTONS_TO_SHOW = [
  'evaluationPendingDocuments',
  'evaluationRejected',
  'evaluationInProcess',
];

export const getColumns = (isMobile) => [
  {
    field: 'folio',
    headerName: 'Folio',
    disableColumnMenu: true,
    flex: isMobile ? 1 : 0,
    headerAlign: isMobile ? 'center' : 'left',
    width: isMobile ? '100%' : 126,
    renderCell: ({ row }) => <FolioCell invoice={row} alignCenter={isMobile} />,
  },
  {
    field: 'dteType_Code',
    headerName: t('dte'),
    sortable: false,
    disableColumnMenu: true,
    width: 86,
    valueGetter: ({ row }) => row.dteType.name,
  },
  {
    field: 'receiver_sortable',
    headerName: 'Receptor',
    disableColumnMenu: true,
    flex: 1,
    renderCell: ({ row }) => <CompanyCell company={row.receiver} />,
  },
  {
    field: 'dateIssued',
    headerName: 'Emisión',
    disableColumnMenu: true,
    width: isMobile ? 90 : 126,
    renderCell: ({ row }) => <DateCell date={row.dateIssued} />,
  },
  {
    field: 'amountWithIva',
    headerName: 'Monto',
    disableColumnMenu: true,
    width: isMobile ? 90 : 126,
    renderCell: ({ row }) => <AmountWithIvaCell row={row} />,
  },
  {
    field: 'preoffer_Preofferevaluationrequest_pendingDocuments',
    headerName: 'Docs. Pendientes',
    sortable: false,
    disableColumnMenu: true,
    width: isMobile ? 100 : 120,
    renderCell: ({ row }) => (
      <PendingDocumentsManagerCell invoice={row} type="Risk" />
    ),
  },
  {
    field: 'preoffer_Preofferevaluationrequest_Status',
    headerName: 'Estado',
    sortable: false,
    disableColumnMenu: true,
    width: isMobile ? 110 : 250,
    renderCell: ({ row }) => (
      <EvaluationStatusCell
        invoice={row}
        type="Operations"
        customDialogTitle="Requisitos para aprobación"
        customDialogSubtitle="Para aprobar tu factura es necesario que cumplas con los siguientes requerimientos:"
      />
    ),
  },
  {
    field: 'uploadDocuments',
    type: 'actions',
    width: isMobile ? 40 : 81,
    renderCell: ({ row }) => <UploadDocumentButton invoiceId={row.id} />,
  },
];
